
import { supabase } from "@/integrations/supabase/client";
import { debugLog, DebugLevel } from "@/utils/debugUtils";

/**
 * Saves the user's word to the database
 */
export const saveUserWordToDatabase = async (
  gameId: string,
  roundNumber: number,
  word: string
) => {
  try {
    // Ensure the word is trimmed before saving
    const trimmedWord = word.trim();
    debugLog(DebugLevel.INFO, "wordSubmission", `Saving user word for round ${roundNumber}: ${trimmedWord}`);
    
    await supabase
      .from("rounds")
      .update({ user_word: trimmedWord })
      .eq("game_id", gameId)
      .eq("round_number", roundNumber);
      
    return { success: true };
  } catch (error) {
    debugLog(DebugLevel.ERROR, "wordSubmission", "Error saving user word:", error);
    return { success: false, error };
  }
};

/**
 * Fetches the bot's word from the database
 */
export const fetchBotWordFromDatabase = async (
  gameId: string,
  roundNumber: number
) => {
  try {
    debugLog(DebugLevel.INFO, "wordSubmission", `Fetching bot word for round ${roundNumber}`);
    
    const { data, error } = await supabase
      .from("rounds")
      .select("ai_word, ai_explanation")
      .eq("game_id", gameId)
      .eq("round_number", roundNumber)
      .maybeSingle();
      
    if (error) {
      throw error;
    }
    
    return { 
      success: true, 
      aiWord: data?.ai_word || "",
      aiExplanation: data?.ai_explanation || undefined,
      hasBotWord: data && data.ai_word && data.ai_word.trim() !== ""
    };
  } catch (error) {
    debugLog(DebugLevel.ERROR, "wordSubmission", "Error fetching bot word:", error);
    return { success: false, error, aiWord: "", aiExplanation: undefined, hasBotWord: false };
  }
};
